import React, {  } from 'react';
import useReactRouter from 'use-react-router';
import { RouteParams } from '../../components/custom-route/custom-route';
import AllowedDocumentsPartner from './components/allowed-documents-partner/allowed-documents-partner';
import AllowedDocumentsUploader from '../../containers/documents/allowed-documents-uploader';

type AllowedDocumentsUploaderSignerProps = {
    nextScreen(): void;
    onBackClick(): void;
};

const AllowedDocumentsSignerUploader: React.FC<AllowedDocumentsUploaderSignerProps> = ({
        nextScreen, onBackClick }): JSX.Element => {
    const { history } = useReactRouter<RouteParams>();

    return (
        <AllowedDocumentsUploader
            nextScreen={nextScreen}
            onBackClick={onBackClick}
        >
            <AllowedDocumentsPartner signer={(history.location.state as any).signer} />
        </AllowedDocumentsUploader>
    );
};

export default AllowedDocumentsSignerUploader;
